/**
* Show a warning banner if the account timezone does not match
* the user's timezone.
*/
define('banner/custom-banners/time-zone-warning',['require','durandal/app','web-urls','i18next','moment-timezone'],function (require) {
    var app = require('durandal/app');
    var webUrls = require('web-urls');
    var i18n = require('i18next');
    var moment = require('moment-timezone');

    return {
        initialize: function (user) {
            var userTimeZone = user.timeZone;
            if (moment().format('HH:mm') !== moment.tz(moment(), userTimeZone).format('HH:mm')) {
                var warningText = i18n.t('meetingtimezone.mainwarning', i18n.t('web-timezones.' + userTimeZone),
                    '<a href="' + webUrls.get('profileUrl') + '">', '</a>');

                var timeZoneBanner = {
                    id: 'invalid-timezone',
                    classes: 'alert alert-warning small-alert',
                    iconClasses: 'togo-icon togo-icon-alert pull-left',
                    message: warningText,
                    disableTime: 1209600000 // 14 days
                };

                app.trigger('banner:addOne', timeZoneBanner);
            }
        }
    };
});

